<!--  -->
<template>
  <div class="project_index_main month_report_main">
    <!-- 面包屑 -->
    <div class="project_breadcrumb_box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/orghome/project_month_report' }">
          项目列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>月报列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 项目信息 -->
    <div class="project_header_box" style="margin-bottom:15px">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.back()">返回项目列表</el-button>
    </div>
    <div class="project_detail_box">
      <div class="project_name_box">{{ projectInfo.project_name || '加载中...' }}</div>
      <div class="project_info_box">
        <p>承接单位：{{ projectInfo.organ_name || '' }}</p>
        <p>
          项目周期：{{ projectInfo.approve_time_str || '' }}
          ~ {{ projectInfo.end_time_str || '' }}
        </p>
      </div>
    </div>

    <!-- 月报记录 -->
    <div class="month_report_content_box">
      <div class="month_report_search_box">
        <h2>月报记录</h2>
      </div>
      <div class="month_report_table_box">
        <el-table :data="tableData">
          <el-table-column label="月份">
            <template slot-scope="scope">
              {{ scope.row.month_report || scope.row.time_name || '' }}
            </template>
          </el-table-column>
          <el-table-column label="项目整体自评进度">
            <template slot-scope="scope">
              <el-progress :percentage="Number(scope.row.progress) || 0"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="提交时间">
            <template slot-scope="scope">
              {{ scope.row.submit_time_str || '' }}
            </template>
          </el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="scope">
              <el-tag
                :type="getStatusType(scope.row)"
                size="small"
              >
                {{ scope.row.status_text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="驳回原因" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.approve_status == 3 && scope.row.refund_reason" style="color:#f56c6c">{{ scope.row.refund_reason }}</span>
              <span v-else style="color:#ccc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <!-- 未提交/草稿/驳回 → 填报/编辑 -->
              <template v-if="scope.row.is_save == 1 || scope.row.approve_status == 3">
                <el-button type="primary" size="small" @click="openFillDialog(scope.row)">
                  {{ scope.row.status_text === '未提交' ? '填报' : '编辑' }}
                </el-button>
              </template>
              <!-- 审核中 → 查看 + 修改 -->
              <template v-else-if="scope.row.is_save == 0 && scope.row.approve_status == 0">
                <el-button type="info" size="small" @click="openViewDialog(scope.row)">
                  查看
                </el-button>
                <el-button type="warning" size="small" @click="handleModifyClick(scope.row)">
                  修改
                </el-button>
              </template>
              <!-- 已审核 → 查看 -->
              <template v-else-if="scope.row.approve_status == 2">
                <el-button type="info" size="small" @click="openViewDialog(scope.row)">
                  查看
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <!-- 空状态 -->
        <div v-if="tableData.length === 0" style="text-align: center; padding: 40px; color: #999">
          暂无月报记录
        </div>
      </div>
    </div>

    <!-- 填报/编辑弹窗 -->
    <el-dialog
      :title="formTitle"
      :visible.sync="detailShow"
      width="1050px"
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="ruleForm" label-position="top" :disabled="isViewMode">
          <el-form-item label="截至当月项目整体自评进度">
            <div style="display: flex; align-items: center">
              <el-input
                style="width: 200px"
                v-model="ruleForm.progress"
                placeholder="项目整体自评进度"
              >
              </el-input>
              <span style="margin-left: 5px; margin-right: 10px">%</span>
              <span style="font-size: 12px; color: #999">
                （请填写 0~100 之间的整数）
              </span>
            </div>
          </el-form-item>
          <el-form-item label="本月重点工作完成情况">
            <el-input
              type="textarea"
              :rows="5"
              v-model="ruleForm.performance"
              placeholder="请输入本月重点工作完成情况"
              :maxlength="200"
              show-word-limit
              :autosize="{ minRows: 5, maxRows: 5 }"
              resize="none"
            >
            </el-input>
            <div style="font-size: 12px; color: #ccc">
              描述本月重点工作的完成进度、关键成果
            </div>
          </el-form-item>
          <el-form-item label="本月遇到的问题与困难">
            <el-input
              type="textarea"
              :rows="5"
              v-model="ruleForm.question"
              placeholder="请输入本月遇到的问题与困难"
              :maxlength="200"
              show-word-limit
              :autosize="{ minRows: 5, maxRows: 5 }"
              resize="none"
            >
            </el-input>
            <div style="font-size: 12px; color: #ccc">
              描述执行中遇到的困难、阻碍及原因分析
            </div>
          </el-form-item>
          <el-form-item label="本月工作总结与亮点">
            <el-input
              type="textarea"
              :rows="5"
              v-model="ruleForm.lightspot"
              placeholder="请输入本月工作总结与亮点"
              :maxlength="200"
              show-word-limit
              :autosize="{ minRows: 5, maxRows: 5 }"
              resize="none"
            >
            </el-input>
            <div style="font-size: 12px; color: #ccc">
              总结亮点做法、创新举措、典型案例
            </div>
          </el-form-item>
          <el-form-item label="下月工作计划">
            <el-input
              type="textarea"
              :rows="5"
              v-model="ruleForm.plan"
              placeholder="请输入下月工作计划"
              :maxlength="200"
              show-word-limit
              :autosize="{ minRows: 5, maxRows: 5 }"
              resize="none"
            >
            </el-input>
            <div style="font-size: 12px; color: #ccc">
              明确下月目标、重点任务、时间节点
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="!isViewMode">
        <el-button @click="detailShow = false" plain type="primary">取 消</el-button>
        <el-button type="warning" @click="handleSaveDraft">保存草稿</el-button>
        <el-button type="primary" @click="handleSubmit">提 交</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button @click="detailShow = false" plain type="primary">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getModuleProjectDetail } from "@/api/module";
import { getReportList, saveReport } from "@/api/module";

export default {
  name: "",

  data() {
    return {
      // 项目ID（从路由获取）
      project_id: 0,
      // 项目详情
      projectInfo: {},
      // 月报列表数据
      tableData: [],
      // 当前月份（如 2026年7月）
      currentMonth: '',
      // 填写弹窗
      detailShow: false,
      // 是否查看模式（只读）
      isViewMode: false,
      // 弹窗标题
      formTitle: '',
      // 月报表单
      ruleForm: {
        id: 0,
        project_id: 0,
        month_report: '',
        progress: 0,
        performance: '',
        question: '',
        lightspot: '',
        plan: '',
        is_save: 1,
      },
    };
  },

  created() {
    this.$emit("setActive", { active: 7 });

    // 从路由获取项目ID
    this.project_id = this.$route.query.projectId || 0;

    if (this.project_id) {
      this.getProjectDetail();
      this.getReportData();
    }
  },

  methods: {
    /**
     * 获取项目详情
     */
    async getProjectDetail() {
      const res = await getModuleProjectDetail(this.project_id);
      if (res && res.code === 200) {
        this.projectInfo = res.data || {};
      }
    },

    /**
     * 获取月报列表
     */
    async getReportData() {
      const res = await getReportList(this.project_id);
      if (res && res.code === 200) {
        this.tableData = res.data.report_list || [];
        this.currentMonth = res.data.current_month || '';
      }
    },

    /**
     * 打开填报/编辑弹窗
     * @param {Object} row 月报记录（编辑时传入）
     */
    openFillDialog(row) {
      this.isViewMode = false;

      if (row) {
        // 编辑已有记录，未提交状态显示"填报"
        const actionText = row.status_text === '未提交' ? '填报月报' : '编辑月报';
        this.formTitle = actionText + ' — ' + (row.month_report || '');
        this.ruleForm = {
          id: row.id || 0,
          project_id: this.project_id,
          month_report: row.month_report || '',
          progress: row.progress || 0,
          performance: row.performance || '',
          question: row.question || '',
          lightspot: row.lightspot || '',
          plan: row.plan || '',
          is_save: 1,
        };
      } else {
        // 新建当前月报
        this.formTitle = '填报月报 — ' + (this.currentMonth || '');
        this.ruleForm = {
          id: 0,
          project_id: this.project_id,
          month_report: this.currentMonth || '',
          progress: 0,
          performance: '',
          question: '',
          lightspot: '',
          plan: '',
          is_save: 1,
        };
      }

      this.detailShow = true;
    },

    /**
     * 打开查看弹窗（只读）
     * @param {Object} row
     */
    openViewDialog(row) {
      this.isViewMode = true;
      this.formTitle = '查看月报 — ' + (row.month_report || '');
      this.ruleForm = {
        id: row.id || 0,
        project_id: this.project_id,
        month_report: row.month_report || '',
        progress: row.progress || 0,
        performance: row.performance || '',
        question: row.question || '',
        lightspot: row.lightspot || '',
        plan: row.plan || '',
        is_save: 1,
      };
      this.detailShow = true;
    },

    /**
     * 点击修改按钮 — 弹窗提示联系管理员
     */
    handleModifyClick(row) {
      this.$confirm(
        '本期月报已提交，若需修改请联系项目管理员解锁',
        '提示',
        {
          confirmButtonText: '知道了',
          cancelButtonText: '取消',
          type: 'warning',
          showCancelButton: false,
        }
      );
    },

    /**
     * 保存草稿
     */
    async handleSaveDraft() {
      const res = await saveReport({
        id: this.ruleForm.id,
        project_id: this.ruleForm.project_id,
        month_report: this.ruleForm.month_report,
        progress: this.ruleForm.progress,
        performance: this.ruleForm.performance,
        question: this.ruleForm.question,
        lightspot: this.ruleForm.lightspot,
        plan: this.ruleForm.plan,
        is_save: 1,
      });

      if (res && res.code === 200) {
        this.$message.success('草稿保存成功');
        this.detailShow = false;
        this.getReportData();
      } else {
        this.$message.error((res && res.message) || '保存失败');
      }
    },

    /**
     * 提交月报
     */
    async handleSubmit() {
      // 简单校验
      if (!this.ruleForm.progress && this.ruleForm.progress !== 0) {
        this.$message.warning('请填写自评进度');
        return;
      }

      this.$confirm('提交后将锁定不可修改，确认提交？', '提示', {
        confirmButtonText: '确认提交',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await saveReport({
          id: this.ruleForm.id,
          project_id: this.ruleForm.project_id,
          month_report: this.ruleForm.month_report,
          progress: this.ruleForm.progress,
          performance: this.ruleForm.performance,
          question: this.ruleForm.question,
          lightspot: this.ruleForm.lightspot,
          plan: this.ruleForm.plan,
          is_save: 0,
        });

        if (res && res.code === 200) {
          this.$message.success('提交成功');
          this.detailShow = false;
          this.getReportData();
        } else {
          this.$message.error((res && res.message) || '提交失败');
        }
      }).catch(() => {});
    },

    /**
     * 列表中的提交按钮
     * @param {Object} row
     */
    async submitReport(row) {
      this.$confirm('确认提交本期月报？提交后将锁定。', '提示', {
        confirmButtonText: '确认提交',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await saveReport({
          id: row.id,
          project_id: this.project_id,
          month_report: row.month_report,
          progress: row.progress,
          performance: row.performance,
          question: row.question,
          lightspot: row.lightspot,
          plan: row.plan,
          is_save: 0,
        });

        if (res && res.code === 200) {
          this.$message.success('提交成功');
          this.getReportData();
        } else {
          this.$message.error((res && res.message) || '提交失败');
        }
      }).catch(() => {});
    },

    /**
     * 获取状态标签样式
     * @param {Object} row
     * @returns {String} el-tag type
     */
    getStatusType(row) {
      if (row.is_save == 1 && row.status_text === '未提交') return 'info';    // 未提交
      if (row.is_save == 1) return 'warning';                                  // 草稿
      if (row.approve_status == 2) return 'success';                           // 已审核
      if (row.approve_status == 3) return 'danger';                            // 已驳回
      return 'warning';                                                         // 审核中
    },
  },
};
</script>

<style scoped lang="scss">
@import url("index.scss");
@import url("month_report.scss");
</style>
